<template>
    <form ref="root" @submit.prevent="onSubmit" class="search-bar">
        <label class="input-wrapper">
            <input
                ref="inputSearch"
                class="input-search"
                type="text"
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                @focus="isSearchBarFocused = true"
                :placeholder="localization.searchBarPlaceholder"
                autocomplete="off"
            >
            <span class="icon-search">
                <img alt="" :src="themeUri + '/assets/localdata/_default/search_icon.svg'">
            </span>
            <span class="button-close" v-if="modelValue.length" @click="onClearInput"></span>
        </label>
    </form>
</template>

<script>
import SearchHints from "./SearchHints";

export default {
    name: "SearchBar",
    components: {
        SearchHints
    },
    data(){
        return {
            isSearchBarFocused: false
        }
    },
    props: {
        modelValue: String
    },
    inject: ['themeUri', 'homeUri', 'localization'],
    emits: [
        'update:modelValue'
    ],
    mounted(){

        this.$refs.inputSearch.focus();  //  Focus.
        this.isSearchBarFocused = true;

        setTimeout(() => {
            document.body.addEventListener('click', this.onOutsideClick);
        }, 1000);

    },
    unmounted(){

        document.body.removeEventListener('click', this.onOutsideClick);

    },
    methods: {
        onSubmit(){
            window.location = this.homeUri + "/?s=" + this.modelValue;
        },
        onClearInput(){
            this.$emit('update:modelValue', "");
        },
        onOutsideClick(event){

            let check = event.path.find(el => {
                return el === this.$refs.root;
            });

            if(!check){
                this.isSearchBarFocused = false;
            }
        }
    },
    computed: {
        shouldDisplayHintBar(){
            return this.modelValue.length > 0 && this.isSearchBarFocused;
        }
    }
}
</script>

<style lang="scss" scoped>
    .search-bar {
        display: block;
    }

    .input-wrapper {
        display: block;
        position: relative;
        margin: 0;
        padding: 0;
    }

    .input-search {
        font-size: 13px;
        background-color: #f2f2f2;
        color: #343434;
        padding: 14px 48px;
        border: none;
        border-radius: unset;
        outline: none;
        width: 100%;
    }

    .icon-search {
        position: absolute;
        pointer-events: none;
        display: inline-block;
        line-height: 0;
        left: 15px;
        top: 50%;
        transform: translateY( -50% );
    }

    .button-close {
        position: absolute;
        cursor: pointer;
        display: block;
        width: 18px;
        height: 18px;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);

        &::after,
        &::before {
            position: absolute;
            display: block;
            content: '';
            width: 100%;
            height: 2px;
            background: #1a1e21;
            top: 50%;
            left: 0;
        }

        &::after {
            transform: translateY(-50%) rotate(45deg);
        }
        &::before {
            transform: translateY(-50%) rotate(-45deg);
        }

    }

</style>